// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 = '<path d="M20 17H22V19H2V17H4V10A8 8 0 1 1 20 10ZM9 21H15V23H9Z"/>';

/** Notification (communication). */
const icon: IconData = {
  id: "bell",
  name: "Notification",
  category: "communication",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M20 17H22V19H2V17H4V10A8 8 0 1 1 20 10ZM18 17V10A6 6 0 0 0 6 10V17ZM9 21H15V23H9Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M15 23H9V21H15ZM13.61 2.16L15.11 2.63 16.47 3.37 17.66 4.34 18.63 5.53 19.37 6.89 19.84 8.39 20 10V17H22V19H2V17H4V10L4.16 8.39 4.63 6.89 5.37 5.53 6.34 4.34 7.53 3.37 8.89 2.63 10.39 2.16 12 2Z"/></g><path d="M20 17H22V19H2V17H4V10A8 8 0 1 1 20 10ZM18 17V10A6 6 0 0 0 6 10V17ZM9 21H15V23H9Z"/>',
    },
  },
  animation: () => import("../animations/bell.js"),
};

export default icon;
